import GeographyPage from './components/GeographyPage';
import HistoryPage from './components/HistoryPage';

const routes = [
  {
    path: '/geography',
    name: 'menu.geography',
    icon: 'pin-map',
    loginRequired: true,
    component: GeographyPage,
    weight: 2,
    permission: [],
    children: [
      // {
      //   path: '/geography/history',
      //   name: 'menu.geography.history',
      //   icon: 'pin-map',
      //   loginRequired: true,
      //   component: HistoryPage,
      //   weight: 2,
      //   permission: [],
      //   children: [],
      // },
    ],
  },
];

export default routes;
